import nextOrPrev from "./_internal/_nextOrPrev.js";

export default nextOrPrev("parentNode");
